import { useNavigate } from "react-router-dom";
import styles from '../cssModules/index.module.css';
import { Dropdown, Form } from 'react-bootstrap';
import { useEffect, useState } from "react";


export default function ShirtUpdate({ id, prod, setProd, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');
    // const { prodId } = useParams();
    // const [prod, setProd] = useState({});
    const navigate = useNavigate();
    let S3_URL = process.env.REACT_APP_S3_URL;

    const fabric = ['Cotton', 'Denim', 'Fleece', 'Rayol', 'Chiffon', 'Wool', 'Art silk', 'Corduroy', 'Crepe', 'Down', 'Faux Fur', 'Fur', 'Georgette', 'Lenin', 'Modal',
        'Rayon', 'Satin', 'Silk', 'Synthetic', 'Velvet', 'Net', 'Rubber'
    ];
    const color = ['red', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];
    const size = ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50',
        '51', '52', '53', '54', '55', '56', '57', '58'
    ];

    const userSegment = ['Men', 'Women', 'Unisex'];

    const fitType = ['Regular', 'Polo', 'Loose', 'Relaxed', 'Semi', 'Athletic', 'Classic', 'Fitted', 'Modern', 'Oversized', 'Skinny', 'Slim',
        'Straight', 'Tailored'
    ];

    const sleeve_size = ['Half Sleeve', 'Long Sleeve', 'Short Sleeve', 'Sleeveless', '3/4 Sleeve']

    const design = ['Solid', 'Striped', 'Graphic', 'Cartoon', 'Animal print', 'Argyle', 'Camouflage', 'Chequered', 'Floral', 'Galaxy', 'Geometric',
        'Hearts', 'Herringbone', 'Letter Print', 'Paisley', 'Plaid', 'Polka Dots', 'Tie Dye', 'Chevron', 'Fruits', 'Houndstooth', 'Stars',
        'Typography Grapic'
    ]

    const pocketDescription = ['Kangaroo Pocket', 'Slant Pocket', 'Cargo Pocket', 'Coin Pocket', 'Flap Pocket',
        'Patch Pocket', 'Round Pocket', 'Slit Pocket', 'Welt Pocket', 'Jetted Pocket', 'Straight Pocket', 'No Pocket'
    ]

    const neckLine = ['Hooded Neck', 'Asymmetric Neck', 'Round Neck', 'Crew Neck', 'Boat Neck', 'Collared Neck', 'Cowl Neck',
        'Henley Neck', 'High Neck', 'Mandarin Neck', 'Mock Neck', 'Scoop Neck', 'Split Neck', 'Square Neck', 'Sweetheart Neck', 'Choker Neck',
        'Turtle Neck', 'V-Neck', 'Criss Cross Neck', 'Halter Neck', 'Keyhole Neck', 'Notch Neck', 'Off Shoulder Neck', 'One Shoulder Neck',
        'Sailor Collar Neck', 'Slit Neck', 'Tie Neck'
    ]

    const specialFeatuee = ['Lightweight', 'Breathable', 'Stretchable', 'Moisture Wicking', 'Quick Dry', 'Sun Protection', 'Absorbent',
        'Adjustable', 'Convertible', 'Removable Padding', 'Removable Padding', 'Removable Padding'
    ]

    const lifeStyle = ['Casual', 'Formal', 'Comfort', 'Business Casual', 'Evening']

    const closureType = ['Pull On', 'Button', 'Zipper', 'Snap', 'Buckle', 'Double Ring', 'Drawstring', 'Hook and Eye', 'Hook and Loop']

    const sleeveCuffStyle = ['Round Cut Cuff', 'Single Cuff', 'Ribbed Cuff', 'Angle Cut Cuff', 'Barrel Cuff', 'Double Cuff', 'French Cuff']

    const occasion = [
        'All', 'Sports', 'Holi', "Womens Day", 'IPL', 'Bengali New Year', 'New Year', 'Durga Puja', 'Friendship Day', 'Independence Day', 'Raksha Bandhan',
        'Janmashtami', 'Ganesh Chaturthi', 'Eid', 'Onam', 'Navratri', 'Diwali', 'Bhai Dooj', 'Christmas', 'Valentines Day', 'Mens Day',
        'Shiv Ratri'
    ];

    const careInstruction = ['Machine Wash', 'Hand Wash Only', 'Dry Clean Only']

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)']

    const stock = ['In stock', 'Out of stock'];

    const [lessGst, setlessGst] = useState(null);
    const [lessPFC, setlessPFC] = useState(null);
    const [revenue, setrevenue] = useState(null);
    const [productionCost, setProductionCost] = useState(300);

    useEffect(() => {
        if (prod['fitType'] === "Polo") {
            setProductionCost(320);
            return;
        }
        setProductionCost(300);

    }, [prod]);

    useEffect(() => {
        let gst = (prod['currentPrice'] * 0.05).toFixed(2);
        let pfc = (prod['currentPrice'] * 0.07).toFixed(2);
        let revenue = (prod['currentPrice'] - gst - pfc - productionCost).toFixed(2);
        setlessGst(gst)
        setlessPFC(pfc)
        setrevenue(revenue);
    }, [prod, productionCost]);

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL}/change/${id}`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify(prod),
                credentials: 'include'
            })
            if (response.status === 200) {
                alert('Updated the product!');
                navigate('/manage');
            } else {
                await loginStatus();
                navigate('/login');
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    const toggleSelection = (size, stock) => {
        try {
            let newArr;
            // prod = { 'additionSize': { 'XL': 20, 'xxl': 24, 'L': 10 } }
            if (stock) {
                // This will handle the situatioin when user already has size previously or not
                newArr = { ...prod['additionsize'], [size]: Number(stock) };
                setProd(prev => {
                    return { ...prev, "additionsize": newArr }
                });
            } else {
                if (Object.keys(prod['additionsize']).includes(size)) {
                    newArr = Object.fromEntries(
                        Object.entries(prod['additionsize']).filter(([key]) => {
                            return key !== size;
                        })
                    )
                    setProd(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                } else {
                    newArr = { ...prod["additionsize"], [size]: null }
                    setProd(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            {prod && (
                <div className={`${styles.sellerUpdate}`}>
                    <form id='uploadForm' onSubmit={handleSubmit}>
                        <div className={`${styles.updateIndividualMainDiv}`}>
                            <img src={`${S3_URL}/${prod.photo1}`} alt='img' className={`${styles.updateIndividualImage}`} />
                            <div className={`${styles.sellerUpdateDiv}`}>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='design'>
                                        Desgin
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='design' name='design' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.design} selected hidden>{prod.design}</option>
                                        {design.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='fabric'>
                                        Fabric
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='fabric' name='fabric' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.fabric} selected hidden>{prod.fabric}</option>
                                        {fabric.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sleeve_size'>
                                        Sleeve size
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='sleeve_size' name='sleeve_size' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.sleeve_size} selected hidden>{prod.sleeve_size}</option>
                                        {sleeve_size.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='pocketDescription'>
                                        Pocket description
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='pocketDescription' name='pocketDescription' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.pocketDescription} selected hidden>{prod.pocketDescription}</option>
                                        {pocketDescription.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='neckLine'>
                                        Neck line
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='neckLine' name='neckLine' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.neckLine} selected hidden>{prod.neckLine}</option>
                                        {neckLine.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='specialFeatuee'>
                                        Special feature
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='specialFeatuee' name='specialFeatuee' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.specialFeature} selected hidden>{prod.specialFeature}</option>
                                        {specialFeatuee.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='lifeStyle'>
                                        Life style
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='lifeStyle' name='lifeStyle' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.lifeStyle} selected hidden>{prod.lifeStyle}</option>
                                        {lifeStyle.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='occasion'>
                                        Occasion
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='occasion' name='occasion' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.occasion} selected hidden>{prod.occasion}</option>
                                        {occasion.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='closureType'>
                                        Closure type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='closureType' name='closureType' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.closureType} selected hidden>{prod.closureType}</option>
                                        {closureType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sleeveCuffStyle'>
                                        sleeveCuffStyle
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='sleeveCuffStyle' name='sleeveCuffStyle' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.sleeveCuffStyle} selected hidden>{prod.sleeveCuffStyle}</option>
                                        {sleeveCuffStyle.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='careInstruction'>
                                        Care instruction
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='careInstruction' name='careInstruction' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.careInstruction} selected hidden>{prod.careInstruction}</option>
                                        {careInstruction.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='name'>
                                        Name
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='name' defaultValue={prod.name} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="Name of the product" name='name' />
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='color'>
                                        Color
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.color} selected hidden>{prod.color}</option>
                                        {color.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='price'>
                                        Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='price' defaultValue={prod.oldPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="price" name='oldPrice' />
                                </div>
                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='size'>
                                        Size
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='size' name='size' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.size} selected hidden>{prod.size}</option>
                                        {size.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div> */}
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='dPrice'>
                                        Discount Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='dPrice' defaultValue={prod.currentPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="This price will be highlighted" name='currentPrice' />
                                </div>
                                {prod.currentPrice && (
                                    <div className={`${styles.sellerUploadLabelDiv}`} >
                                        <label>
                                            Less GST
                                            <input type='text' value={lessGst + ' INR'} disabled style={{ marginLeft: '10px', width: '100px' }} />
                                        </label>
                                        <label>
                                            Less Raw material Cost
                                            <input type='text' value={productionCost + ' INR'} disabled style={{ marginLeft: '10px', width: '100px' }} />
                                        </label>
                                        <label>
                                            Less Platform Commission
                                            <input type='text' value={lessPFC + ' INR'} disabled style={{ marginLeft: '10px', width: '100px' }} />
                                        </label>
                                        <label>
                                            Your revenue
                                            <input type='text' value={revenue + ' INR'} disabled style={{ marginLeft: '10px', width: '100px' }} />
                                        </label>
                                    </div>
                                )}
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='user'>
                                        User segment
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='user' name='userSegment' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.userSegment} selected hidden>{prod.userSegment}</option>
                                        {userSegment.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>


                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        Stock
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='stock' name='active' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.active} selected hidden>{prod.active}</option>
                                        {stock.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>


                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='fitType'>
                                        Fit type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='fitType' name='fitType' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.fitType} selected hidden>{prod.fitType}</option>
                                        {fitType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='availability'>
                                        Availability
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='availability' name='availability' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value === 'true' }) })} required form="uploadForm">
                                        <option value={prod.availability} selected hidden>{prod.availability ? 'True' : 'False'}</option>
                                        <option value={'true'}>True</option>
                                        <option value={'false'}>False</option>
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='weightCat'>
                                        Weight category (Courier ready)
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='weightCat' name='weightCat' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.weightCat} selected hidden>{changeWeightCatReverse(prod.weightCat)}</option>
                                        {weightCat.map(item => {
                                            return (
                                                <>
                                                    <option value={changeWeightCat(item)}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>
                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        In stock
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='stock' defaultValue={prod.stock} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="Available stock" name='stock' />
                                </div> */}

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary">Sizes</Dropdown.Toggle>
                                        <Dropdown.Menu
                                        // bsPrefix={`form-control, ${styles.dropdownMenu}`}
                                        >
                                            {size.map((option, idx) => (
                                                <>
                                                    <div className={`${styles.formControlDiv}`}>
                                                        <div style={{ flexBasis: '50%', fontSize: '13px' }}>
                                                            <Form.Check
                                                                key={idx}
                                                                type="checkbox"
                                                                label={option}
                                                                checked={Object.keys(prod['additionsize']).includes(option)}
                                                                onChange={() => toggleSelection(option, null, 'additionsize')}
                                                                className="px-3"
                                                            />
                                                        </div>
                                                        <div style={{ flexBasis: '50%' }}>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Stock'
                                                                key={idx}
                                                                value={prod['additionsize'][option] ? prod['additionsize'][option] : null}
                                                                onChange={(e) => toggleSelection(option, e.target.value, 'additionsize')}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sku'>
                                        Stock keeping unit
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                        onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="SKU" name='sku' />
                                </div>

                            </div>
                            <input type="submit" value='UPDATE' className={`${styles.sellerUpdateButton}`} />
                        </div>
                    </form>
                </div>
            )}
        </>
    )
}